module.exports = __webpack_public_path__ + "img/bluesky3100_14.3874395c.jpg";